import { actionCopyDe } from "./actionCopy";
import { listCopyDe } from "./listCopy";

export const studiesCopyDe = {
    studies: "Studien",
    description:
        "Erstellen Sie Studien und laden Sie Behandler mit Label-, Formular-, Vorlagen- und Abrechnungszugriff ein.",
    unauthorizedMessage: "Studien sind nur für Administratoren und Manager verfügbar.",
    searchPlaceholder: "Studien, Labels, Formulare oder Vorlagen durchsuchen",
    searchAriaLabel: "Studien durchsuchen",
    clearSearchAria: actionCopyDe.clearSearch,
    filterStudiesAria: "Studien filtern",
    studyFilterDescription: "Studien nach Status und Abrechnungstarif filtern.",
    newStudy: "Neue Studie",
    noStudiesYet: "Noch keine Studien. Erstellen Sie Ihre erste Studie, um Zugriff und Einladungen zu konfigurieren.",
    noStudiesMatchSearch: "Keine Studien entsprechen Ihrer Suche oder Ihren Filtern.",
    columnStudyName: "Studienname",
    columnLabel: "Label",
    columnForms: "Formulare",
    columnTemplates: "Vorlagen",
    columnPlan: "Tarif",
    columnExpiry: "Ablauf",
    columnDiaries: "Tagebücher",
    columnClinicians: "Behandler",
    columnStatus: listCopyDe.status,
    columnActions: listCopyDe.actions,
    published: listCopyDe.published,
    draft: listCopyDe.draft,
    open: actionCopyDe.open,
    invite: actionCopyDe.invite,
    edit: actionCopyDe.edit,
    openStudyAria: "Studie öffnen",
    inviteStudyAria: "Behandler zu dieser Studie einladen",
    editStudyAria: "Studie bearbeiten",
    openTrackingAria: "Studienfortschritt und Diagramme öffnen",
    trackingDialogTitle: (studyName: string) => `Fortschritt · ${studyName}`,
    emptyLabel: " - ",
    templateCount: (count: number) => `${count} Vorlage${count === 1 ? "" : "n"}`,
    newStudyTitle: "Neue Studie",
    newStudyDescription:
        "Konfigurieren Sie Label-, Formular- und Vorlagenzugriff, Abrechnung und Sichtbarkeit für Manager.",
    editStudyTitle: "Studie bearbeiten",
    editStudyDescription:
        "Aktualisieren Sie Label-, Formular- und Vorlagenzugriff, Abrechnung und Sichtbarkeit für Manager.",
    studySaved: "Studie gespeichert",
    failedToSaveStudy: "Studie konnte nicht gespeichert werden",
    saveStudy: "Studie speichern",
    saveChanges: "Änderungen speichern",
    studyName: "Studienname",
    studyNamePlaceholder: "z. B. Elite Tendon Knee 2026",
    labelAccess: "Label-Zugriff",
    selectLabels: "Labels auswählen",
    addLabel: "Label hinzufügen",
    labelName: "Labelname",
    labelNamePlaceholder: "z. B. Elite Tendon Knee",
    formAccess: "Formularzugriff",
    selectForms: "Formulare auswählen",
    templates: "Vorlagen",
    inferredAccessTitle: "Zugriff aus Vorlagen",
    inferredAccessDescription:
        "Fragebögen, Zeitpläne und Ereignisse aus den gewählten Vorlagen werden automatisch gewährt.",
    inferredAccessEmpty: "Wählen Sie eine oder mehrere Vorlagen, um den Zugriff abzuleiten.",
    inferredEvents: "Ereignisse",
    inferredForms: "Fragebögen",
    inferredSchedules: "Zeitpläne",
    inferredNone: "Keine",
    customiseAccessTitle: "Zugriff anpassen",
    customiseAccessHideTitle: "Zugriffsoptionen ausblenden",
    customiseAccessDescription:
        "Volle Kontrolle über Modi und private Freigaben. Vorlagenpflichtige Fragebögen, Zeitpläne und Ereignisse bleiben ausgewählt.",
    loadingAccessOptions: "Zugriffsoptionen werden geladen…",
    billingPlan: "Abrechnungstarif",
    selectPlan: "Tarif auswählen",
    expiryDate: "Ablaufdatum",
    pickDate: "TT/MM/JJJJ",
    expiryDateMinMessage: "Das Ablaufdatum muss morgen oder später liegen",
    expiryDateMaxMessage: "Bitte innerhalb der nächsten 100 Jahre wählen",
    expiryDateInvalidMessage: "Dieses Datum sieht nicht richtig aus",
    publishStudyForManagers: "Studie veröffentlichen",
    labelAccessSummary: "Label-Zugriff",
    formAccessSummary: "Formularzugriff",
    templatesSummary: "Vorlagen",
    billingPlanSummary: "Abrechnungstarif",
    expirySummary: "Ablauf",
    statusSummary: "Status",
    loadingStudy: "Studie wird geladen…",
    studyNotFound: "Studie nicht gefunden",
    backToStudies: "Zurück zu Studien",
    studyInvite: "Studieneinladung",
    inviteToStudy: (studyName: string) => `Zur Studie ${studyName} einladen`,
    inviteToStudyDescription:
        "Teilen Sie einen QR-Code oder Link, damit sich Behandler anmelden und dieser Studie beitreten können. Organisation und Fachrichtung sind optional.",
    inviteStepReview: "Prüfen",
    inviteStepEmail: "E-Mail",
    inviteStepQr: "QR",
    inviteStepInvite: "Einladen",
    generatingInviteLink: "Einladungslink wird erstellt…",
    failedToCreateInviteLink: "Einladungslink konnte nicht erstellt werden",
    studyInviteQrDescription: (studyName: string) =>
        `Teilen Sie einen QR-Code oder Link, damit sich Behandler anmelden und ${studyName} beitreten können. Organisation und Fachrichtung kommen aus den Studienstandardwerten.`,
    joinStudyTitle: (studyName: string) => `${studyName} beitreten`,
    optionalOrganisationSignupHint:
        "Optional. Leer lassen, damit der Behandler die eigene Organisation im Onboarding anlegt.",
    clinicianWillChooseOrganisation: "Der Behandler wählt oder erstellt die Organisation bei der Anmeldung.",
    specialty: "Fachrichtung",
    optionalSuffix: "(optional)",
    optionalSpecialtySignupHint:
        "Optional. Wenn gesetzt, wird die Fachrichtung auf Behandler angewendet, die dieser Studie beitreten.",
    selectSpecialtyPlaceholder: "Fachrichtung wählen",
    clearSpecialty: "Löschen",
    clinicianInviteDefaultsTitle: "Standardwerte für Behandler-Einladungen",
    clinicianInviteDefaultsDescription:
        "Optional Organisation und Fachrichtung für Behandler festlegen, die per QR oder Link beitreten.",
    defaultOrganisation: "Organisation",
    noOrganisationsAvailable: "Keine Organisationen zur Auswahl verfügbar.",
    inviteDefaultsSummary: (summary: string) => `Einladungsstandard: ${summary}`,
    inviteDefaultsEmpty:
        "Keine Organisation oder Fachrichtung für diese Studie festgelegt. Behandler setzen dies im Onboarding.",
    emailRequired: "E-Mail-Adresse ist erforderlich",
    validEmailRequired: "Geben Sie eine gültige E-Mail-Adresse ein",
    studyInviteEmailSent: "Studieneinladung per E-Mail gesendet",
    failedToSendInvite: "Einladung konnte nicht gesendet werden",
    trackingTitle: "Studien-Tracking",
    trackingDescription: "Behandler mit den Labels dieser Studie und die von ihnen erstellten Tagebücher.",
    trackingLabelsHint: "Labels",
    trackingLoading: "Tracking wird geladen…",
    trackingError: "Studien-Tracking konnte nicht geladen werden.",
    trackingNoLabels: "Fügen Sie Labels hinzu, um Behandler und Tagebücher zu verfolgen.",
    trackingNoClinicians: "Noch keine Behandler mit diesen Labels.",
    trackingNoDiaries: "Noch keine Tagebücher mit den Labels dieser Studie.",
    trackingCliniciansWithAccess: "Behandler mit Zugriff",
    trackingCliniciansHint: (members: number, withLabels: number) =>
        `${members} Studienmitglied${members === 1 ? "" : "er"} · ${withLabels} mit Label-Zugriff`,
    trackingTotalDiaries: "Tagebücher",
    trackingAvgDiariesPerClinician: "Ø Tagebücher / Behandler",
    trackingCliniciansWithDiaries: "Behandler mit Tagebüchern",
    trackingDiariesPerClinician: "Tagebücher pro Behandler",
    trackingCumulativeDiaries: "Kumulierte Tagebücher",
    trackingClinicianTableTitle: "Behandler",
    trackingColumnClinician: "Behandler",
    trackingColumnDiaries: "Tagebücher",
    trackingColumnAccess: "Zugriff",
    trackingAccessMember: "Studienmitglied",
    trackingAccessLabel: "Label-Zugriff",
    trackingAccessDiaryOnly: "Nur Tagebücher",
    trackingCliniciansShort: "Behandler",
    trackingNoLabelsShort: "Keine Labels",
    trackingNoDiariesShort: "Noch keine Tagebücher",
};
